import store from 'app/store';

export default (entity, name = null) => {
  const existing = store.get().getState().upload;
  const uploads = existing.filter(u => u.entity === entity);

  if (typeof name !== 'string') {
    return uploads;
  }

  return uploads.filter(u => u.name === name).first() || null;
};
